import VacationUser from 'features/vacations-application/vacationUser';
import { useTitle } from '../helpers';

/**
 * @page UserPage
 */

const VacationsApplicationsUserPage = () => {
  useTitle('Информация о заявлении');

  return (
    <>
      <h3>Информация о заявлении</h3>
      <VacationUser />
    </>
  );
};

export default VacationsApplicationsUserPage;
